import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/root-store/state';
import { SpecializationPickerComponent } from '../../specialization-picker/specialization-picker.component';

@Injectable({
  providedIn: 'root'
})
export class SpecializationPickerService {

  public pickCategory(successActionDispatcher: (categoryIds: number[])=>void, initialData: number[]=[]){
    let dialogRef = this.dialog.open(SpecializationPickerComponent, {
      //height: 'calc(100vh - 4rem)',
      //maxHeight: '48rem',
      width: '48rem',
      panelClass: 'common-dialog-container',
      data: {
        categoryIds: initialData
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result !== undefined && result !== null){
        successActionDispatcher(result);
      }
    });
  }

  public pickSpecialization(successActionDispatcher: (specializationIds: string[])=>void, initialData: string[]=[]){
    const dialogRef = this.dialog.open(SpecializationPickerComponent, {
      width: '48rem',
      panelClass: 'common-dialog-container',
      data: {
        specializationIds: initialData
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result !== undefined && result !== null){
        successActionDispatcher(result);
      }
    });
  }

  constructor(private dialog: MatDialog, private store: Store<AppState>) { }
}
